import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useRepsOutletContext } from 'pages/Reps'
import { SubmitHandler } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { Reps, UpdateRepSchema, reps } from 'service/api'
import { toast } from 'sonner'
import FormReps from '../forms/FormReps'

export default function EditarRep() {
    const { id } = useParams()
    const { data } = useRepsOutletContext()
    const r = data?.find(item => item.id === Number(id))

    const { mutateAsync, isLoading } = reps.mutations.useUpdate({
        invalidateQuery: true,
    })

    if (!r) return null

    const handleSubmit: SubmitHandler<Reps> = data =>
        mutateAsync(data, {
            onSuccess: () => {
                toast.success('Rep atualizado com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <Dialog.Root
            height="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            defaultValues={r}
            schema={UpdateRepSchema}
            open={hasPermission(['update', 'Reps'])}
        >
            <Dialog.Title>Editar Rep</Dialog.Title>
            <Dialog.Content dividers>
                <FormReps isEdicao />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
